/* eslint-disable */
import embLabels from "../../../config/emb-labels-en.json";
import ACTIONS from "../Design_Asset_Actions.json";
import ApiSession from "../../../api/ApiSession";

const apiSession = new ApiSession();

const useAssetSelection = (deps) => {
  const {
    projectTypeValue, dispatch, UserScope, projectType,
    loading, setLoading,
    displayPage, setDisplayPage,
    sldLoadCompleted, setSldLoadCompleted,
    useCaseValidGenset, setUseCaseValidGenset,
    deleteOneDER, setDeleteOneDER,
    defaultConfigurationStatus, setDefaultConfigurationStatus,
    siteCreated, setSiteCreated,
    isOpen, setIsOpen,
    siteType, setSiteType,
    evceDiagramChangeRequired, setEvceDiagramChangeRequired,
    isAllowMultipleLoads, setIsAllowMultipleLoads,
    isExportOptimization, setIsExportOptimization,
    switchboardType, setSwitchboardType,
    clientType, setClientType,
    architectureType, setArchitectureType,
    nominalVoltage, setNominalVoltage,
    isSelectSpanishCode, setIsSelectSpanishCode,
    defaultPreFillData, setDefaultPreFillData,
    availableDer, setAvailableDer,
    useCases, setUseCases,
    isEvce, setIsEvce,
    prevPvGroupNames, setPrevPvGroupNames,
    batteryCommunicationData, setBatteryCommunicationData,
    evCommunicationData, setEvCommunicationData,
    powerMeter, setPowerMeter,
    communicationState, setCommunicationState,
    cbCommunicationValues, setCbCommunicationValues,
    detailsBlock, setDetailsBlock,
    selectedValues, setSelectedValues,
    configData, setConfigData,
    isLoadNameUnique, setIsLoadNameUnique,
    gsxExternalId, setGsxExternalId,
    isBessController, setIsBessController,
    assetDetailsDisplay, setAssetDetailsDisplay,
    assetInfo, setAssetInfo,
    bessControllerPrevValue, setBessControllerPrevValue,
    cbDer, setCbder,
    CBValues, setCBValues,
    defaultsMinMax, setDefaultsMinMax,
    coordinates, setCoordinates,
    rectangleWidth, setRectangleWidth,
    snackBar, setSnackBar,
    alert, setAlert,
    confirm, setConfirm,
    remoteConfirm, setRemoteConfirm,
    duplicateUpdate, setDuplicateUpdate,
    runCalculateCoordinates, setRunCalculateCoordinates,
    runGenerateComponentsBlock, setRunGenerateComponentsBlock,
    batteryRack, setBatteryRack,
    batterySystemA2EConfig, setBatterySystemA2EConfig,
    isOpenLoadConfig, setIsOpenLoadConfig,
    isOpenGtConfig, setIsOpenGtConfig,
    loadSide, setLoadSide,
    isAntiIslandingRelayEnable, setIsAntiIslandingRelayEnable,
    gridTransitionOnline, setGridTransitionOnline,
    defaultCbData, setDefaultCbData,
    defaultPmData, setDefaultPmData,
    defaultDummyCbData, setDefaultDummyCbData,
    gensetAssetData, setGensetAssetData,
    evContactorData, setEVContactorData,
    gTContractorData, setGTContractorData,
    defaultGTData, setGTDefaultData,
    evDefaultData, setEVDefaultData,
    evPMData, setEVPMData,
    jsonData, setJsonData,
    isContactorEnabled, setIsContactorEnabled,
    cbLoadData, setCBLoadData,
    currentProject, setCurrentProject,
    defaultComponentData, setDefaultComponentData,
    updateComponents, setUpdateComponents,
    cbCount, setCbCount,
    spanishCodeRealTime, setSpanishCodeRealTime,
    assetDefaultValues, setAssetDefaultValues,
    isAssetConfigChanged, setIsAssetConfigChanged,
    gtTempConfigData, setGtTempConfigData,
    projectStatusData,
    deploymentReady, setDeploymentReady,
    ComponentData, ComponentDataDispatch,
    CBAssetList, CBAssetListDispatch,
    CBEVList, CBEVListDispatch,
    CBLoadList, CBLoadListDispatch,
    CBGTList, CBGTListDispatch,
    firstTimeCall, setFirstTimecall,
    multipleLoads, setMultipleLoads,
    count, countDispatch,
    projectKind, projectKindDispatch,
    PVDetails, PVDetailsDispatch,
    selectedLoadIndx, setSelectedLoadIndx,
    projectId,
    initialRenderCoordinates,
    initialRenderPvConfigured,
    snackBarRef,
    isUpdatingComponent,
    remoteMain, setRemoteMain,
    considerSelected, setConsiderSelected,
    assetDetails, setAssetDetails,
    // projectKind flags
    isMgaasAnsi, isDaasAnsi, isDaasEto, isMgaasIec, isDaasIec,
    isMgaasAnsiGrid, isDaasAnsiGrid, isDaasEtoGrid,
    isMgaasAnsiIsland, isDaasAnsiIsland, isDaasEtoIsland,
    isMgaasIecGrid, isDaasIecGrid, isMgaasIecIsland,
    isGridConnected, isGridConnectedGSX, isIslandable, isIslandableGSX,
    isA2E, isLineSide, isExistingSwitchBoard, isLoadSide, isNewSwitchBoard,
    isGreenStruxure, isGeneric, isGreenStruxureMicrogrid,
    isPVGensetATS, isFuelSaver, isPVBessNR, isPVHybrid, isPVGensetA2E,
    isGensetMainNoBess, isNoFuel, isETO,
    isMGaaSETOGrid, isMGaaSETOIsland, isMGaaSETO, isMGaaSETOGensetPvHybrid,
    isNMGaaSETOGrid, isNMGaaSETOIsland, isNMGaaSETO, isNMGaaSETOGensetPvHybrid,
    isMgaasAnsiOffGrid, isMgaasIecOffGrid, isMassEtoOffGrid,
    // cross-hook ref
    fnRef,
    
  } = deps;

  // Cross-hook function aliases
  const callSnackbar = (...args) => fnRef.current.callSnackbar(...args);
  const generateComponentsBlock = (...args) => fnRef.current.generateComponentsBlock(...args);
  const gtCbConfigDataHandler = (...args) => fnRef.current.gtCbConfigDataHandler(...args);
const filterHybridModel = (...args) => fnRef.current.filterHybridModel(...args);
  const setAssetSelection = (assetName, cbDer) => {
    // setIsOpenLoadConfig(false);
    setCbder(cbDer);
    PVDetailsDispatch({
      type: ACTIONS.CLOSE_PVDISPLAY_CONTENT,
      payload: {
        selectSubPv: PVDetails?.selectSubPv,
        selectedPv: PVDetails?.selectedPv,
      }
    });

    const newAssetInfo = { ...assetInfo, assetSelected: true };
    setAssetInfo(newAssetInfo);
    getAssets(assetName);
  };

  const getAssets = (type) => {
    setAssetInfo((prevState) => ({ ...prevState, manufacturerLoading: true }));
    apiSession
      .getAssetsList(type, projectId)
      .then((json) => {
        const manufacturer = [];
        let standardTemplate = "";
        json.assetCatalogue[0].assetList.forEach((data) => {
          if (type === embLabels.GENERATOR) {
            if (data.manufacturer === "STANDARD GENSET TEMPLATE") {
              standardTemplate = data.manufacturer;
            } else {
              manufacturer.push(data.manufacturer);
            }
          } else if (type === embLabels.BESS) {
            if (data.manufacturer === "STANDARD BESS TEMPLATE") {
              standardTemplate = data.manufacturer;
            } else {
              manufacturer.push(data.manufacturer);
            }
          } else if (type === embLabels.PV_INVERTER) {
            if (data.manufacturer === "STANDARD PV INVERTER SUNSPEC TEMPLATE") {
              standardTemplate = data.manufacturer;
            } else {
              manufacturer.push(data.manufacturer);
            }
          } else {
            manufacturer.push(data.manufacturer);
          }
        });
        manufacturer.sort();

        if (standardTemplate !== "") {
          manufacturer.splice(0, 0, standardTemplate);
        }

        const modelType = [];
        json.assetCatalogue[0].assetList.forEach((data) => {
          if (modelType[data.manufacturer]) {
            modelType[data.manufacturer].push(data.communicationModel);
          } else {
            modelType[data.manufacturer] = [];
            modelType[data.manufacturer].push(data.communicationModel);
          }
          modelType[data.manufacturer].sort();
        });

        const uniqueManufactures = [...new Set(manufacturer)];

        const newAssetInfo = {
          ...assetInfo,
          assets: json.assetCatalogue[0].assetList,
          assetManufacturer: uniqueManufactures,
          assetModelType: modelType,
          manufacturerLoading: false,
          assetSelected: true,
        };
        setAssetInfo(newAssetInfo);
      })
      .catch(() => {
        setAssetInfo((prevState) => ({
          ...prevState,
          manufacturerLoading: false,
        }));
      });
  };

  const selectManufacturer = (e) => {
    const newAssetInfo = { ...assetInfo, selectedManufacturer: e.target.value };
    setAssetInfo(newAssetInfo);
  };

  const closeAssetSelectionBlock = () => {
    setAssetInfo((prevState) => ({
      ...prevState,
      assetSelected: false,
      selectedManufacturer: "",
    }));
  };

  const selectAssetFromList = (data) => {
    let selectedAsset = {};
    const assetDetailsData = { ...assetDetailsDisplay };
    setIsBessController(false);
    let isMasterBessAsset = false;
    assetInfo.assets.forEach((assetData) => {
      if (parseInt(assetData.assetId) === parseInt(data)) {
        assetDetailsData.assetId = assetData.assetId;
        assetDetailsData.manufacturer = assetData.manufacturer;
        assetDetailsData.communicationModel = assetData.communicationModel;
        assetDetailsData.assetInfo = assetData.assetInfo;
        assetDetailsData.imageLink = assetData.imageLink;
        assetDetailsData.assetName = assetData.assetType;
        selectedAsset = assetData;
      }
    });
    CBAssetListDispatch({
      type: ACTIONS.SELECTED_ASSET,
      payload: {
        selectedAsset: selectedAsset,
      },
    });
    setAssetDetailsDisplay(assetDetailsData);

    setAssetInfo((prevState) => ({
      ...prevState,
      assetSelected: false,
      selectedManufacturer: "",
    }));
    const configDataNew = configData?.configData &&  { ...configData?.configData };
    const preFillDefault = defaultPreFillData?.[0];
    if(!configDataNew) return;
    switch (selectedAsset?.assetType) {
      //* GENSET

      case embLabels.GENERATOR:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 1,
            selectedAsset,
          },
        });
        if (selectedAsset?.assetAttributes?.length) {
          selectedAsset?.assetAttributes.forEach((data, index) => {
            switch (selectedAsset?.assetAttributes?.[index]?.type) {
              case "max_power":
                configDataNew.max_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "starting_timer":
                configDataNew.starting_timer =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "cooling_timer":
                configDataNew.cooling_timer =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "minimum_running_period":
                configDataNew.minimum_running_period =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              default:
                break;
            }
          });
          // CBAssetListDispatch({
          //   type:ACTIONS.ASSET_SELECTED_CONFIG,
          //   payload: {
          //     selectedAsset: selectedValues.selectedAsset,
          //     configData: configDataNew,
          //   },
          // });
        } else {
          configDataNew.max_power = defaultsMinMax?.maxPowerGensetDefault;
          configDataNew.min_power = "";
          configDataNew.gensetCO2 = defaultsMinMax?.gensetCO2Default;
          configDataNew.starting_timer = defaultsMinMax?.startUpGensetDefault;
          configDataNew.cooling_timer =
            defaultsMinMax?.coolingDurationGensetDefault;
          configDataNew.minimum_running_period =
            defaultsMinMax?.minRunningDurationGensetDefault;
        }
        if (selectedAsset?.assetInfo === embLabels.SERIAL) {
          const newModbusId =
            preFillDefault?.Generator?.ipAddress?.split(".")[3];
          CBAssetListDispatch({
            type: ACTIONS.SELECT_SERIAL_ASSET,
            payload: {
              index: 1,
              modbusSlaveId: newModbusId,
            },
          });
        } else if (
          CBAssetList?.[1].communicationData.ipaddress === "" &&
          selectedAsset?.assetInfo === embLabels.COMMUNICATING
        ) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_COMMUNICATING_ASSET,
            payload: {
              index: 1,
              preFillDefault: preFillDefault?.Generator,
            },
          });
        }
        break;

      //* BESS

      case embLabels.BESS:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 2,
            selectedAsset,
          },
        });

        if (selectedAsset?.assetAttributes?.length) {
          configDataNew.isBoostPro = false;
          selectedAsset?.assetAttributes?.forEach((data, index) => {
            if(selectedAsset?.assetAttributes?.[index]?.type === "isMultiBess"){
              setIsBessController( selectedAsset?.assetAttributes?.[index]?.value)
            }
            switch (selectedAsset?.assetAttributes?.[index]?.type) {
              case "max_power":
                if (
                  selectedAsset?.assetAttributes?.[index]?.value?.includes("[")
                ) {
                  try {
                    configDataNew.max_power = JSON.parse(
                      selectedAsset?.assetAttributes?.[index]?.value
                    )?.[0];
                  } catch (error) {
                    configDataNew.max_power = "";
                  }
                } else {
                  configDataNew.max_power =
                    selectedAsset?.assetAttributes[index].value;
                  setBessControllerPrevValue(prev=>{
                    return{
                      ...prev,
                      max_power:selectedAsset?.assetAttributes?.[index]?.value
                    }
                  })
                }

                break;
              case "starting_timer":
                configDataNew.starting_timer =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "soc_max":
                configDataNew.soc_max =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "capacity":
                configDataNew.capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                  setBessControllerPrevValue(prev=>{
                    return{
                      ...prev,
                      capacity:selectedAsset?.assetAttributes?.[index]?.value
                    }
                  });
                break;
              case "soc_min":
                configDataNew.soc_min =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "soc_nominal_power":
                configDataNew.soc_nominal_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "SoC_fallback":
                configDataNew.SoC_fallback =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "usableStorageCapacityHr":
                configDataNew.storage_capacity_hr =
                  selectedAsset?.assetAttributes?.[index]?.value;

                break;
              case "usableStorageCapacity":
                configDataNew.corresponding_name_plate_capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_solar_power":
                configDataNew.max_solar_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_inverter_output_power":
                configDataNew.max_inverter_output_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "quantityOfBess":
                configDataNew.quantityOfBessList = JSON.parse( selectedAsset?.assetAttributes[index]?.value);
                   configDataNew.quantityOfBess =JSON.parse( selectedAsset?.assetAttributes[index]?.value)?.[0];
                    setBessControllerPrevValue(prev=>{
                    return{
                      ...prev,
                      quantityOfBess:JSON.parse( selectedAsset?.assetAttributes[index]?.value)?.[0]
                    }
                  })
                break;
              case "Number_Of_BESS":
                configDataNew.quantityOfBessList = JSON.parse( selectedAsset?.assetAttributes[index]?.value);
                   configDataNew.quantityOfBess =JSON.parse( selectedAsset?.assetAttributes[index]?.value)?.[0];
                    configDataNew.isBoostPro = true;
                break;
              case "perUnitMaxPower":
                configDataNew.perUnitMaxPower = selectedAsset?.assetAttributes?.[index]?.value;
                if(selectedAsset?.assetAttributes?.[index]?.type === "isMultiBess"){
                  configDataNew.max_power = Number(configDataNew.quantityOfBess || 1) * Number(selectedAsset?.assetAttributes?.[index]?.value);

                }

                break;
              case "perUnitMaxEnergy":
                configDataNew.perUnitMaxEnergy = selectedAsset?.assetAttributes[index]?.value;
                if(selectedAsset?.assetAttributes?.[index]?.type === "isMultiBess"){
                  configDataNew.capacity = Number(configDataNew?.quantityOfBess || 1) * Number(selectedAsset?.assetAttributes?.[index]?.value)

                }
                break;
              case "isMasterBessController":
                  configDataNew.quantityOfBess = configDataNew.quantityOfBessList?.[0] || 2;
                   configDataNew.isMasterBessController = true;
                   configDataNew.isMultiBess = false;
                break;
                case "isMultiBess":
                  configDataNew.quantityOfBess = configDataNew.quantityOfBessList?.[0] || 1;
                   configDataNew.isMultiBess = true;
                   configDataNew.isMasterBessController = false;
                break;
                default:
                break;
            }
           
          });
          
        } else {
          configDataNew.max_power = defaultsMinMax?.maxPowerBessDefault;
          configDataNew.starting_timer = "";
          configDataNew.capacity = 0;
          configDataNew.soc_max = defaultsMinMax?.socMaxDefault;
          configDataNew.soc_min = defaultsMinMax?.socMinDefault;
          configDataNew.soc_nominal_power = 60;
          configDataNew.SoC_fallback = 60;
        }

        if (selectedAsset?.assetInfo === embLabels.SERIAL) {
          const newModbusId = preFillDefault?.BESS?.ipAddress.split(".")[3];
          CBAssetListDispatch({
            type: ACTIONS.SELECT_SERIAL_ASSET,
            payload: {
              index: 2,
              modbusSlaveId: newModbusId,
            },
          });
        } else if (CBAssetList[2].communicationData.ipaddress === "") {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_COMMUNICATING_ASSET,
            payload: {
              index: 2,
              preFillDefault: preFillDefault?.BESS,
            },
          });
        }
        break;

      //* CHP

      case embLabels.CHP:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 6,
            selectedAsset,
          },
        });

        if (selectedAsset?.assetAttributes.length) {
          selectedAsset?.assetAttributes.forEach((data, index) => {
            switch (selectedAsset?.assetAttributes[index].type) {
              case "nominalPower":
                configDataNew.nominal_power =
                  selectedAsset?.assetAttributes[index].value;
                break;
              default:
                break;
            }
          });
        } else {
          configDataNew.nominal_power = defaultsMinMax?.chpNominalPowerMax;
        }

        break;

      //* Hybrid

      case embLabels.HYBRID:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 7,
            selectedAsset,
          },
        });

        if (selectedAsset?.assetAttributes?.length) {
          selectedAsset?.assetAttributes?.forEach((_, index) => {
            switch (selectedAsset?.assetAttributes[index].type) {
              case "max_capacity":
                configDataNew.max_capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                if (selectedAsset?.assetAttributes?.[index].value === "240") {
                  setBatteryRack("2");
                } else {
                  setBatteryRack("1");
                }
                break;
              case "capacity":
                configDataNew.capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_solar_power":
                configDataNew.max_solar_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_inverter_output_power":
                configDataNew.max_inverter_output_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "usableStorageCapacityHr":
                configDataNew.storage_capacity_hr =
                  selectedAsset?.assetAttributes?.[index]?.value;

                break;
              case "usableStorageCapacity":
                configDataNew.corresponding_name_plate_capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;

              default:
                break;
            }
          });

          setDefaultComponentData((prevData) => ({
            ...prevData,
            defaultComponentData: selectedAsset,
          }));
          if(selectedAsset){
            setBatterySystemA2EConfig(prev=>{
              const hybridModels = selectedAsset?.assetAttributes?.find(
                (assetType) => assetType.type === "hybridModels"
              )?.value.split(",");
              const {storageCapacity, timeCapacity} = filterHybridModel(selectedAsset?.assetAttributes, hybridModels?.[0]);
              setConfigData((prevState) => ({
                ...prevState,
                configData:{ 
                  ...prevState.configData,
                  hybridModels:hybridModels,
                  namePlateEnergy:storageCapacity,
                  time_capacity:timeCapacity
                  },
              }));
              return {
                ...prev,
                model:hybridModels,
                namePlateEnergy:storageCapacity,
              }
            });
           
           
          }
        } else {
          configDataNew.max_capacity = 0;
          configDataNew.capacity = 0;
          configDataNew.max_solar_power = 0;
          configDataNew.max_inverter_output_power = 0;
          configDataNew.storage_capacity_hr = [];
          configDataNew.corresponding_name_plate_capacity = [];
        }

        if (
          +CBLoadList[0]?.configData?.maximum_available_power >
          +configDataNew?.max_inverter_output_power
        ) {
          CBLoadListDispatch({
            type: ACTIONS.DUPLICATE_LOAD_UPDATE,
            payload: {
              selectedLoad: 0,
            },
          });
        }

        CBAssetListDispatch({
          type: ACTIONS.DUPLICATE_DER_UPDATE,
          payload: {
            selectedAsset: 1,
          },
        });
        break;

      //* PV

      case embLabels.PV_inverter_assettype:
        

        if (PVDetails?.selectedPv === 3) {
          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_CONFIG,
            payload: {
              selectedAsset,
              selectedPv: 3,
              defaultsMinMax: defaultsMinMax,
            },
          });
        }
        if (PVDetails?.selectedPv === 4) {
          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_CONFIG,
            payload: {
              selectedAsset,
              selectedPv: 4,
              defaultsMinMax: defaultsMinMax,
            },
          });
        }
        if (PVDetails?.selectedPv === 5) {
          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_CONFIG,
            payload: {
              selectedAsset,
              selectedPv: 5,
              defaultsMinMax: defaultsMinMax,
            },
          });
        }

        //     this.onChangePvSubSelection(this.state.selectSubPv);
        break;

      //* ev

      case embLabels.EV_CHARGING_STATION:
        CBEVListDispatch({
          type: ACTIONS.SELECT_EV_ASSET,
          payload: {
            index: selectedValues?.selectedEv,
            selectedAsset,
          },
        });
         let checkTmh = selectedAsset?.communicationModel?.toLowerCase() === "tmh_controller";

        if(checkTmh){
          configDataNew.name = "TMH-Controller";
        }
        if (selectedAsset?.assetAttributes?.length) {
          selectedAsset?.assetAttributes?.forEach((attribute) => {
            switch (attribute.type) {
              case "max_power":
                configDataNew.maximum_available_power = attribute.value;
                break;
              default:
                break;
            }
          });
        } else {
          configDataNew.maximum_available_power = 10;
        }

        if (selectedAsset?.assetInfo === embLabels.SERIAL) {
          const newModbusId =
            preFillDefault?.EV_charging_station?.ipAddress?.split(".")[3];

          CBEVListDispatch({
            type: ACTIONS.SELECT_SERIAL_ASSET,
            payload: {
              index: selectedValues?.selectedEv,
              modbusSlaveId: newModbusId,
            },
          });
        } else if (
          CBEVList?.[selectedValues?.selectedEv]?.communicationData?.ipaddress === ""
        ) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_COMMUNICATING_ASSET,
            payload: {
              index: selectedValues?.selectedEv,
              preFillDefault: preFillDefault?.EV_charging_station,
            },
          });
        }

        break;

      case embLabels.CIRCUIT_BREAKER:
        if (CBAssetList?.some((cbasset) => cbasset.uiData.CBSelected)) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_DER_CBASSET,
            payload: {
              index: selectedValues?.selectedAssetCB,
              selectedAsset,
              cbCommunicationValues,
              CBValues,
              defaultValues: defaultPreFillData?.[0],
              count,
              switchboardType,
              projectTypeValue
            },
          });
        }

        if (CBLoadList?.some((cbload) => cbload.uiData.CBSelected)) {
          CBLoadListDispatch({
            type: ACTIONS.SELECT_LOAD_CBASSET,
            payload: {
              index: selectedValues?.selectedLoadCB,
              selectedAsset,
              cbCommunicationValues,
              defaultValues: defaultPreFillData?.[0],
              count,
              siteType,
              projectTypeValue
            },
          });
         
        }
        if (CBEVList?.some((cbev) => cbev.uiData.CBSelected)) {
          CBEVListDispatch({
            type: ACTIONS.SELECT_EV_CBASSET,
            payload: {
              index: selectedValues?.selectedEvCB,
              selectedAsset,
              cbCommunicationValues,
            },
          });         
        }
        if (CBGTList.some((cbev) => cbev.uiData.CBSelected)) {
          CBGTListDispatch({
            type: ACTIONS.SELECT_GT_CBASSET,
            payload: {
              index: selectedValues.selectedGtCB,
              selectedAsset,
              cbCommunicationValues,
            },
          });      
           assetDetailsReset();
        if (UserScope.access.saveSLD) {
          const assetBlock = "gtDetailsBlock";
          const selectedAssetValue = "selectedGt";
          let index = selectedValues.selectedGtCB;
          CBGTListDispatch({
                type: ACTIONS.GT_SELECT,
                payload: {
                index,
                },
            });
         setIsOpenGtConfig(true);
         selectedValuesHandler(index, selectedAssetValue, assetBlock);
         gtCbConfigDataHandler(index);
         gtConfigDataHandler(index);
        }
      }
        break;

      case embLabels.CONTACTOR:
        if (CBAssetList?.some((cbasset) => cbasset.uiData.CBSelected)) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_DER_CB_CONTACTOR_ASSET,
            payload: {
              index: selectedValues?.selectedAssetCB,
              selectedAsset,
            },
          });
        }
        if (CBEVList?.some((cbev) => cbev.uiData.CBSelected)) {
          CBEVListDispatch({
            type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
            payload: {
              index: selectedValues?.selectedEvCB,
              selectedAsset: selectedAsset,
            },
          });
        }
        if(CBLoadList?.some((cbload) => cbload.uiData.CBSelected)){
          CBLoadListDispatch({
            type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
            payload: {
              index: selectedValues?.selectedLoadCB,
              selectedAsset: selectedAsset,
            },
          });
        }

        break;

      case embLabels.POWER_METER:
        if (
          CBAssetList?.some(
            (cbasset) =>
              cbasset.uiData.pmSelected || cbasset.uiData.existingPmSelected
          )
        ) {
          if (detailsBlock?.existingPmAssetDetailsBlockGrid) {
            CBAssetListDispatch({
              type: ACTIONS.SELECT_DER_EXISTING_PMASSET,
              payload: {
                index: selectedValues?.selectedAssetPM,
                selectedAsset,
                defaultValues: defaultPreFillData?.[0],
                existingPMBlock: detailsBlock.existingPmAssetDetailsBlockGrid,
              },
            });
          } else {
            CBAssetListDispatch({
              type: ACTIONS.SELECT_DER_PMASSET,
              payload: {
                index: selectedValues?.selectedAssetPM,
                selectedAsset,
                defaultValues: defaultPreFillData?.[0],
              },
            });
          }
        }
        if (CBEVList?.some((cbev) => cbev.uiData.pmSelected)) {
          CBEVListDispatch({
            type: ACTIONS.SELECT_EV_PMASSET,
            payload: {
              index: selectedValues?.selectedEvPM,
              selectedAsset,
              preFillDefault: preFillDefault?.["Power Meter"],
            },
          });
        }
        if(CBLoadList?.some((cbLoad) => cbLoad.uiData.pmSelected)){
          CBLoadListDispatch({
            type: ACTIONS.SELECT_LOAD_PMASSET,
            payload: {
              index: selectedValues?.selectedLoad ===""?selectedValues?.selectedLoadPM:selectedValues?.selectedLoad,
              selectedAsset,
              preFillDefault: preFillDefault?.["Power Meter"],
            },
          })
        }
        break;
      default:
        break;
    }

    const cbCofigDataNew = {
      ...configData?.cbConfigData,
    };
    if (
      [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE, embLabels.OFF_GRID].includes(siteType) &&
      clientType === embLabels.GENERIC_PROJECT &&
      selectedAsset.assetType === embLabels.CIRCUIT_BREAKER &&
      (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO"|| projectTypeValue === "NMGaaS ETO") &&
      (selectedAsset?.assetInfo === "Serial" ||
        selectedAsset?.assetInfo === "Communicating")
    ) {
      cbCofigDataNew.motorized = true;
    }

    setConfigData((prevState) => ({
      ...prevState,
      configData: configDataNew,
      cbConfigData: cbCofigDataNew,
    }));
   
    sessionStorage.setItem("deploymentReady", false);
    setDeploymentReady("false");
    sessionStorage.setItem("componentDataModified", true);
    setIsAssetConfigChanged(configData);
  };

  const assetDetailsReset = () => {
    CBAssetListDispatch({
      type: ACTIONS.CLOSEDETAILS_ASSET,
    });
    CBLoadListDispatch({
      type: ACTIONS.CLOSEDETAILS_LOAD,
    });
    CBEVListDispatch({
      type: ACTIONS.CLOSEDETAILS_EV,
    });
    const newAssetDetails = { ...detailsBlock };
    Object.keys(newAssetDetails).forEach(
      (block) => (newAssetDetails[block] = false)
    );
    const configData = {
      name: "",
      description: "",
      min_power: "",
      max_power: "",
    };
    const cbConfigData = {
      name: "",
      description: "",
    };
    const contactorConfigData = {
      name: "",
      description: "",
    };
    const newAssetDetailsDisplay = { ...assetDetailsDisplay };
    Object.keys(newAssetDetailsDisplay).forEach(
      (details) => (newAssetDetailsDisplay[details] = "")
    );
    setDetailsBlock(newAssetDetails);
    setConfigData((prevState) => ({
      ...prevState,
      configData,
      cbConfigData,
      contactorConfigData,
    }));
    setAssetDetailsDisplay(newAssetDetailsDisplay);
  };

  const selectedValuesHandler = (
    index,
    selectedAssetValue,
    selectedAssetBlcok
  ) => {
    setConsiderSelected(true);
    const newSelectedValuess = { ...selectedValues };
    Object.keys(newSelectedValuess).forEach(
      (block) => (newSelectedValuess[block] = "")
    );

    if (selectedAssetBlcok !== "hardWiredCbDetailsBlockGrid") {
      setSelectedValues({
        ...newSelectedValuess,
        [selectedAssetValue]: index,
      });
    }
    if (selectedAssetBlcok === "loadDetailsBlock") {
      setSelectedValues({
        ...newSelectedValuess,
        ["selectedLoadCB"]: index,
        ["selectedLoad"]:index,
      });
    }
    if (selectedAssetBlcok === "gtDetailsBlock") {
      setSelectedValues({
        ...newSelectedValuess,
        ["selectedGtCB"]: index,
        ["selectedGt"]:index,
      });
    }
    setDetailsBlock((prevState) => ({
      ...prevState,
      [selectedAssetBlcok]: true,
    }));
  };

  const selectedSubPvHandler = (index) =>
    setSelectedValues((prevState) => ({
      ...prevState,
      selectSubPv: index,
    }));

  const selectedAssetHandler = (type, index) => {
    let assetArrayIn;
    switch (type) {
      case embLabels.ASSETS:
        assetArrayIn = [...CBAssetList];
        break;
      case embLabels.EV_CHARGING_STATION:
        assetArrayIn = [...CBEVList];
        break;
      default:
        break;
    }

    const assetDetailsData = { ...assetDetailsDisplay };
    if (assetArrayIn?.[index]?.assetDetails !== undefined) {
      if (assetArrayIn?.[index]?.assetDetails?.length) {
        assetDetailsData.assetId =
          assetArrayIn[index]?.assetDetails[0]?.assetId;
        assetDetailsData.manufacturer =
          assetArrayIn[index]?.assetDetails[0]?.manufacturer;
        assetDetailsData.communicationModel =
          assetArrayIn[index]?.assetDetails[0]?.communicationModel;
        assetDetailsData.assetInfo =
          assetArrayIn[index]?.assetDetails[0]?.assetInfo;
        assetDetailsData.assetName =
          assetArrayIn[index]?.assetDetails[0]?.assetName;
        assetDetailsData.imageLink =
          assetArrayIn[index]?.assetDetails[0]?.imageLink;
        setAssetDetailsDisplay(assetDetailsData);
      } else {
        const newAssetDetailsDisplay = { ...assetDetailsDisplay };
        Object.keys(newAssetDetailsDisplay).forEach(
          (details) => (newAssetDetailsDisplay[details] = "")
        );
        setAssetDetailsDisplay(newAssetDetailsDisplay);
      }
    }
  };

  const selectedAssetHandlerPv = (selectedPv, selectSubPv) => {
    let indexValue = parseInt(selectSubPv - 1);
    let newPvSubData = [];

    switch (selectedPv) {
      case 3:
        newPvSubData = [...PVDetails?.pvset1Data];
        break;
      case 4:
        newPvSubData = [...PVDetails?.pvset2Data];
        break;
      case 5:
        newPvSubData = [...PVDetails?.pvset3Data];
        break;
      default:
        break;
    }

    const assetDetailsData = { ...assetDetailsDisplay };

    if (newPvSubData[indexValue]?.assetDetails !== undefined) {
      if (newPvSubData[indexValue]?.assetDetails?.length) {
        assetDetailsData.assetId =
          newPvSubData[indexValue]?.assetDetails[0]?.assetId;
        assetDetailsData.manufacturer =
          newPvSubData[indexValue]?.assetDetails[0]?.manufacturer;
        assetDetailsData.communicationModel =
          newPvSubData[indexValue]?.assetDetails[0]?.communicationModel;
        assetDetailsData.assetInfo =
          newPvSubData[indexValue]?.assetDetails[0]?.assetInfo;
        assetDetailsData.assetName =
          newPvSubData[indexValue]?.assetDetails[0]?.assetName;
        assetDetailsData.imageLink =
          newPvSubData[indexValue]?.assetDetails[0]?.imageLink;
        setAssetDetailsDisplay(assetDetailsData);
      } else {
        const newAssetDetailsDisplay = { ...assetDetailsDisplay };
        Object.keys(newAssetDetailsDisplay).forEach(
          (details) => (newAssetDetailsDisplay[details] = "")
        );
        setAssetDetailsDisplay(newAssetDetailsDisplay);
      }
    }
   
  };
    const loadSelectHandler = () => {
      setSelectedLoadIndx(null);
      assetDetailsReset();
      setDetailsBlock(prev=>({
        ...prev,
        loadDetailsBlock:true,
      }))
      };
       const gtSelectHandler = () => {
      // setSelectedLoadIndx(null);
      assetDetailsReset();
      setDetailsBlock(prev=>({
        ...prev,
        gtDetailsBlock:true,
      }))
      };
     
  //* GET CONFIG DATA


  return {
    setAssetSelection,
    getAssets,
    selectManufacturer,
    closeAssetSelectionBlock,
    selectAssetFromList,
    assetDetailsReset,
    selectedSubPvHandler,
    selectedAssetHandler,
    selectedAssetHandlerPv,
    loadSelectHandler,
    gtSelectHandler,
    selectedValuesHandler,
  };
};

export default useAssetSelection;